import React, { useContext } from "react";
import { MeetingContext } from "@/pages/Meeting";
import * as meetingtool from "../mtools";
import { useMqtt } from "@/hooks/use-mqtt";
import { Commond, RoleCode } from "@/types";
import { Avatar, Button, Col, Dropdown, Input, List, Menu, Modal, Row, Tabs, Tag, message } from "antd";
import styled from "styled-components";
import { AudioIcon, PinIcon, VideoIcon } from "@/component/ToggleIcon";
import { conference } from "@/api";
import { MoreOutlined } from "@ant-design/icons";

const Container = styled.div`
  padding: 10px 3px;
  border-bottom: 1px solid rgb(232, 232, 232);
  display: flex;
  align-items: center;
  &:hover {
    background: rgb(232, 232, 232);
  }
  .avatarFrm {
    width: 40px;
    height: 40px;
    .avatar {
      background: #1890ff;
    }
  }
  .names {
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    .name {
      font-weight: bold;
    }
    .host {
      margin-top: 5px;
      padding: 2px 5px;
      border-radius: 2px;
      display: inline-block;
      background: rgb(143, 149, 158);
      color: #fff;
    }
  }
  .actions {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;

    .ant-btn:hover, .ant-btn:focus {
      color: rgba(0, 0, 0, 0.85);
      border-color: rgb(217, 217, 217);
    }
  }
`;

const Actions: React.FC<{ terminal: any; roomId: string; connected: boolean }> = ({
  terminal,
  roomId,
  connected,
}) => {
  const [loading, setLoading] = React.useState(false);

  const runAction = async () => {
    if (loading) return;
    const updatedTerminal = { ...terminal, roomId: terminal.roomId || roomId };
    if (!updatedTerminal.roomId) {
      message.error("缺少房间号，无法执行呼叫操作");
      return;
    }
    setLoading(true);
    try {
      if (connected) {
        await conference.cancelCallTerminal(updatedTerminal);
        message.success("已发送挂断请求");
      } else {
        await conference.callTerminal(updatedTerminal);
        message.success("已发送呼叫请求");
      }
    } catch (error: any) {
      message.error(error?.message || (connected ? "挂断失败" : "呼叫失败"));
    } finally {
      setLoading(false);
    }
  };

  return <>
    <Button
      shape="circle"
      onClick={runAction}
      className="mr5"
      loading={loading}
      title={connected ? "挂断终端" : "呼叫终端"}
      icon={connected
        ? <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3411" width="13" height="13"><path d="M94.3 447.5c166.9-162.1 702.6-136.9 842.7 2.8 39.3 39.1 21.4 152.9 1.4 172.4-26.6 11.7-189.8-26.2-216-44.2-6.5-6.7-9.2-16.3-13.4-32.7-4.8-19-10.7-42.6-31.3-63.2-40.7-40.6-269.3-44.4-309.6-5.2-18.4 17.8-25.6 40.6-32 60.7-5.2 16.6-10.1 31.8-19.8 41.3-23.4 17.4-186.6 44.2-223.9 37.1-41-45.8-34.3-133.9 1.9-169z" p-id="3412" fill="#d81e06"></path></svg>
        : <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3361" width="13"  height="13"><path d="M692.02938649 588.79179644c32.73904397-32.73904397 83.43860018-35.77960313 119.14749263-6.01040764L927.35452327 675.05882374c38.67874093 29.76919549 44.68914857 86.40844866 14.91995308 125.08718959-2.96984848 2.96984848-2.96984848 5.93969696-5.93969696 5.93969697l-80.39804102 80.39804102c-77.42819254 77.42819254-285.95398231-32.80975465-485.49951596-232.3552883C170.7502674 454.72435072 63.55287937 249.23912011 138.01122343 171.81092757L218.40926445 91.41288655c35.77960313-35.77960313 92.34814562-35.77960313 125.15790027 0l5.93969696 5.93969696 92.27743495 116.17764415c29.76919549 35.70889245 26.79934701 86.33773798-6.01040764 119.14749263l-50.62884553 50.62884553c32.80975465 53.59869401 68.5186471 101.32840174 110.1672365 142.97699116 41.71930009 41.71930009 89.37829714 77.49890322 142.97699116 110.16723651l53.74011537-47.65899705z"  p-id="3362"  fill="#1296db"  ></path></svg>}
    />
  </>
}

export const Member = ({ user }: any) => {
  const { service } = useContext(MeetingContext);
  const { publish } = useMqtt()

  let {
    participants,
    conference: conf,
    updateConference,
    setParticipants
  } = useContext(MeetingContext);

  // console.log("Member user:", conf, "isSelf:");

  const participant = React.useMemo(() => {
    return participants.find((item) => {
      return item.peerId === `${conf.roomId}_${user.userId}` || null
    })
  }, [conf.roomId, participants, user.userId])

  const isSelf = React.useMemo(() => {
    return conf.userId === user.userId;
  }, [conf.userId, user.userId])
  const participantConnected = Boolean(participant);
  // 在线状态严格按“是否在当前会议 participants 中”判断，避免后端账号/终端在线态残留导致误判
  const resolvedOnline = isSelf ? true : participantConnected;

  const togglePin = () => {
    service.pin(participant.peerId, !participant.pinned);
  }

  const isManage = meetingtool.selfIsManage(conf, participants);

  const muteAction = () => {
    // 是自己的话， 可以
    // 自己是管理对方不是，可以
    const isme = meetingtool.isSelf(conf, participant);
    const isManage = meetingtool.selfIsManage(conf, participants);
    const peer = meetingtool.getPeer(conf, participant, participants);
    // 自己的
    const meok =
      isme && (conf.allowSelfUnmute || (!conf.allowSelfUnmute && peer.audio));

    const otherok = !isme && isManage && peer.roleCode === RoleCode.guest;

    if (meok || otherok) {
      const action = peer.audio ? Commond.singleMute : Commond.singleUnMute;
      // doAction(action);
      publish({
        command: peer.audio ? Commond.singleMute : Commond.singleUnMute,
        data: {
          peerId: `${conf.roomId}_${user.userId}`,
          operatorPeerId: `${conf.roomId}_${conf.userId}`,
        },
      })
    }
  };

  const videoAction = () => {
    // 是自己的话， 可以
    // 自己是管理对方不是，可以
    const isme = meetingtool.isSelf(conf, participant);
    const isManage = meetingtool.selfIsManage(conf, participants);
    const peer = meetingtool.getPeer(conf, participant, participants);
    if (isme || (isManage && peer.roleCode === RoleCode.guest)) {
      const action = peer.video ? Commond.shieldVideos : Commond.openVideos;
      // doAction(action);

      publish({
        command: peer.video ? Commond.shieldVideos : Commond.openVideos,
        data: {
          peerId: `${conf.roomId}_${user.userId}`,
          operatorPeerId: `${conf.roomId}_${conf.userId}`,
        },
      })
    }
  };

  const removeUser = () => {
    // doAction(Commond.removeUser, "")
    publish({ command: Commond.removeUser, data: { peerId: participant.peerId }})
  };

  const broadcastUser = () => {
    if (!participant) return;
    publish({
      command: Commond.broadcastParticipant,
      data: {
        peerId: participant.peerId,
        operatorPeerId: `${conf.roomId}_${conf.userId}`,
      },
    });
  };

  const menu = (
    <Menu>
      {isManage && (
        <Menu.Item key="broadcast">
          <span onClick={broadcastUser}>广播该用户</span>
        </Menu.Item>
      )}

      {isManage && (
        <Menu.Item key="a4">
          <span onClick={removeUser}>移出会议</span>
        </Menu.Item>
      )}
    </Menu>
  );
  return (
    <>
      <Container key={user.userId}>
        <div className="avatarFrm">
          <Avatar className="avatar" size={40} style={{background: resolvedOnline ? '#1890ff' : '#7d7d7d'}}>
            {user.nickname ? user.nickname.charAt(0).toUpperCase() : 'U'}
          </Avatar>
        </div>
        <div className="names">
          <div className="name">{user.nickname || user.name || '未知用户'} ({isSelf ? "我" : resolvedOnline ? "在线" : "离线"}) {!isSelf && <Tag color="blue">{ user.platformType }</Tag>}</div>
        </div>
        <div className="actions">
          {/* 在这里添加你想要的操作按钮 */}
          {resolvedOnline && participant && <Button
            shape="circle"
            onClick={togglePin}
            className="mr5"
            icon={<PinIcon active={participant.pinned} />}
          />}
          {}
          {!isSelf && isManage && resolvedOnline && participant && (
            <>
              <Button
                shape="circle"
                onClick={muteAction}
                className="mr5"
                icon={<AudioIcon active={participant.audio} />}
              />
              <Button
                shape="circle"
                className="mr5"
                onClick={videoAction}
                icon={<VideoIcon active={participant.video} />}
              />

              <Dropdown overlay={menu}>
                <Button shape="circle" icon={<MoreOutlined rotate={90} />} />
              </Dropdown>
            </>
          )}
          {user.platformType !== 'USER' && (
            <Actions
              terminal={user}
              roomId={conf.roomId}
              connected={resolvedOnline}
            />
          )}
          {user.platformType === 'USER' && !resolvedOnline && <Button
            shape="circle"
            onClick={() => {
              publish({ command: Commond.inviteMeeting, data: { conferenceNo: conf.conferenceNo, roomId: conf.roomId, userId: user.userId, terminalType: user.terminalType }}, "meeting")
            }}
            className="mr5"
            icon={<svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3361" width="13"  height="13"><path d="M692.02938649 588.79179644c32.73904397-32.73904397 83.43860018-35.77960313 119.14749263-6.01040764L927.35452327 675.05882374c38.67874093 29.76919549 44.68914857 86.40844866 14.91995308 125.08718959-2.96984848 2.96984848-2.96984848 5.93969696-5.93969696 5.93969697l-80.39804102 80.39804102c-77.42819254 77.42819254-285.95398231-32.80975465-485.49951596-232.3552883C170.7502674 454.72435072 63.55287937 249.23912011 138.01122343 171.81092757L218.40926445 91.41288655c35.77960313-35.77960313 92.34814562-35.77960313 125.15790027 0l5.93969696 5.93969696 92.27743495 116.17764415c29.76919549 35.70889245 26.79934701 86.33773798-6.01040764 119.14749263l-50.62884553 50.62884553c32.80975465 53.59869401 68.5186471 101.32840174 110.1672365 142.97699116 41.71930009 41.71930009 89.37829714 77.49890322 142.97699116 110.16723651l53.74011537-47.65899705z"  p-id="3362"  fill="#1296db"  ></path></svg>}
          />}
        </div>
      </Container>
    </>
  )
}
